// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2017, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.CBGSliceAnimated--segment--EakS3 {
  stroke-width: 2;
  pointer-events: all;
}

@keyframes CBGSliceAnimated--fadeRangeOut--vdW8u {
  from {
    stroke: var(--trends--light);
  }
  to {
    stroke: var(--trends--light--faded);
  }
}

@keyframes CBGSliceAnimated--fadeRangeIn--hPW2F {
  from {
    stroke: var(--trends--light--faded);
  }
  to {
    stroke: var(--trends--light);
  }
}

.CBGSliceAnimated--rangeSegment--v32EM {
  animation: CBGSliceAnimated--fadeRangeIn--hPW2F 0.25s forwards ease-in-out;
  fill: transparent;
}

.CBGSliceAnimated--rangeSegmentFaded--GoVwG {
  animation: CBGSliceAnimated--fadeRangeOut--vdW8u 0.25s forwards ease-in-out;
  fill: transparent;
}

.CBGSliceAnimated--rangeSegment--v32EM:hover, .CBGSliceAnimated--rangeSegmentFaded--GoVwG:hover {
  opacity: 0;
}

@keyframes CBGSliceAnimated--fadeOuterOut--kZAoN {
  from {
    fill: var(--trends--light);
    stroke: var(--trends--light);
  }
  to {
    fill: var(--trends--light--faded);
    stroke: var(--trends--light--faded);
  }
}

@keyframes CBGSliceAnimated--fadeOuterIn--RUeYr {
  from {
    fill: var(--trends--light--faded);
    stroke: var(--trends--light--faded);
  }
  to {
    fill: var(--trends--light);
    stroke: var(--trends--light);
  }
}

.CBGSliceAnimated--outerSegment--K2fMH {
  animation: CBGSliceAnimated--fadeOuterIn--RUeYr 0.25s forwards ease-in-out;
}

.CBGSliceAnimated--outerSegmentFaded--SLwMD {
  animation: CBGSliceAnimated--fadeOuterOut--kZAoN 0.25s forwards ease-in-out;
}

.CBGSliceAnimated--outerSegment--K2fMH:hover, .CBGSliceAnimated--outerSegmentFaded--SLwMD:hover {
  opacity: 0;
}

@keyframes CBGSliceAnimated--fadeInnerOut--ct2l4 {
  from {
    fill: var(--trends--dark);
    stroke: var(--trends--dark);
  }
  to {
    fill: var(--trends--dark--faded);
    stroke: var(--trends--dark--faded);
  }
}

@keyframes CBGSliceAnimated--fadeInnerIn--rL7xu {
  from {
    fill: var(--trends--dark--faded);
    stroke: var(--trends--dark--faded);
  }
  to {
    fill: var(--trends--dark);
    stroke: var(--trends--dark);
  }
}

.CBGSliceAnimated--innerQuartilesSegment--JAS6B {
  animation: CBGSliceAnimated--fadeInnerIn--rL7xu 0.25s forwards ease-in-out;
}

.CBGSliceAnimated--innerQuartilesSegmentFaded--SFNkd {
  animation: CBGSliceAnimated--fadeInnerOut--ct2l4 0.25s forwards ease-in-out;
}

.CBGSliceAnimated--innerQuartilesSegment--JAS6B:hover, .CBGSliceAnimated--innerQuartilesSegmentFaded--SFNkd:hover {
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/trends/cbg/CBGSliceAnimated.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAMF;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,0EAAiD;EACjD,iBAAiB;AACnB;;AAEA;EACE,2EAAkD;EAClD,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,iCAAiC;IACjC,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,iCAAiC;IACjC,mCAAmC;EACrC;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;AACF;;AAEA;EACE,0EAAiD;AACnD;;AAEA;EACE,2EAAkD;AACpD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;EACA;IACE,gCAAgC;IAChC,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,kCAAkC;EACpC;EACA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;AACF;;AAEA;EACE,0EAAiD;AACnD;;AAEA;EACE,2EAAkD;AACpD;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2017, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n:export {\n  stroke: 2;\n}\n\n.segment {\n  stroke-width: 2;\n  pointer-events: all;\n}\n\n@keyframes fadeRangeOut {\n  from {\n    stroke: var(--trends--light);\n  }\n  to {\n    stroke: var(--trends--light--faded);\n  }\n}\n\n@keyframes fadeRangeIn {\n  from {\n    stroke: var(--trends--light--faded);\n  }\n  to {\n    stroke: var(--trends--light);\n  }\n}\n\n.rangeSegment {\n  animation: fadeRangeIn 0.25s forwards ease-in-out;\n  fill: transparent;\n}\n\n.rangeSegmentFaded {\n  animation: fadeRangeOut 0.25s forwards ease-in-out;\n  fill: transparent;\n}\n\n.rangeSegment:hover, .rangeSegmentFaded:hover {\n  opacity: 0;\n}\n\n@keyframes fadeOuterOut {\n  from {\n    fill: var(--trends--light);\n    stroke: var(--trends--light);\n  }\n  to {\n    fill: var(--trends--light--faded);\n    stroke: var(--trends--light--faded);\n  }\n}\n\n@keyframes fadeOuterIn {\n  from {\n    fill: var(--trends--light--faded);\n    stroke: var(--trends--light--faded);\n  }\n  to {\n    fill: var(--trends--light);\n    stroke: var(--trends--light);\n  }\n}\n\n.outerSegment {\n  animation: fadeOuterIn 0.25s forwards ease-in-out;\n}\n\n.outerSegmentFaded {\n  animation: fadeOuterOut 0.25s forwards ease-in-out;\n}\n\n.outerSegment:hover, .outerSegmentFaded:hover {\n  opacity: 0;\n}\n\n@keyframes fadeInnerOut {\n  from {\n    fill: var(--trends--dark);\n    stroke: var(--trends--dark);\n  }\n  to {\n    fill: var(--trends--dark--faded);\n    stroke: var(--trends--dark--faded);\n  }\n}\n\n@keyframes fadeInnerIn {\n  from {\n    fill: var(--trends--dark--faded);\n    stroke: var(--trends--dark--faded);\n  }\n  to {\n    fill: var(--trends--dark);\n    stroke: var(--trends--dark);\n  }\n}\n\n.innerQuartilesSegment {\n  animation: fadeInnerIn 0.25s forwards ease-in-out;\n}\n\n.innerQuartilesSegmentFaded {\n  animation: fadeInnerOut 0.25s forwards ease-in-out;\n}\n\n.innerQuartilesSegment:hover, .innerQuartilesSegmentFaded:hover {\n  opacity: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stroke": `2`,
	"segment": `CBGSliceAnimated--segment--EakS3`,
	"rangeSegment": `CBGSliceAnimated--rangeSegment--v32EM`,
	"fadeRangeIn": `CBGSliceAnimated--fadeRangeIn--hPW2F`,
	"rangeSegmentFaded": `CBGSliceAnimated--rangeSegmentFaded--GoVwG`,
	"fadeRangeOut": `CBGSliceAnimated--fadeRangeOut--vdW8u`,
	"outerSegment": `CBGSliceAnimated--outerSegment--K2fMH`,
	"fadeOuterIn": `CBGSliceAnimated--fadeOuterIn--RUeYr`,
	"outerSegmentFaded": `CBGSliceAnimated--outerSegmentFaded--SLwMD`,
	"fadeOuterOut": `CBGSliceAnimated--fadeOuterOut--kZAoN`,
	"innerQuartilesSegment": `CBGSliceAnimated--innerQuartilesSegment--JAS6B`,
	"fadeInnerIn": `CBGSliceAnimated--fadeInnerIn--rL7xu`,
	"innerQuartilesSegmentFaded": `CBGSliceAnimated--innerQuartilesSegmentFaded--SFNkd`,
	"fadeInnerOut": `CBGSliceAnimated--fadeInnerOut--ct2l4`
};
export default ___CSS_LOADER_EXPORT___;
